import { TipoPersona } from '@shared/enums/TipoPersona';
import { SubArea } from '../abm/SubArea';
import { CondicionIVA } from '../facturacion/CondicionIVA';
import { ActividadAFIP } from './AcividadAFIP';
import { CBU } from './CBU';
import { ConfigClienteProvincia } from './ConfigClienteProvincia';
import { Cuenta } from './Cuenta';
import { GrupoCliente } from './GrupoCliente';
import { Responsable } from './Responsable';
import { Ubicacion } from './Ubicacion';
import { ViaDePago } from './ViaDePago';
import { UsuarioDTO } from "@shared/models/notificaciones";

export class Cliente{
    id: string;
    razonSocial: string;
    numeroDocumento: string;
    tipoDocumento: number;
    tipoDocumentoDescripcion?: string;
    condicionPrecio: number;
    direccionFiscal: Ubicacion;
    responsable: Responsable;
    condicionIva: CondicionIVA;
    direccionesEntrega: Ubicacion[];
    ctaSap: string;
    ctA_CTC: string;
    esNuevo: boolean;
    configuracionProvincialImp: ConfigClienteProvincia[];
    // actividad: Actividad;
    esTrader: boolean;
    permiteRanchos: boolean;
    comerciales: string[];
    ejecutivoCuenta: UsuarioDTO;
    percepcionIVADif?: number;
    fechaPercepcionIVADif?: string;
    activo: boolean;
    clienteObservado: boolean;
    grupoCliente: GrupoCliente;
    cuentas: Cuenta[];
    subArea: SubArea;
    actividadPAD: number;
    actividadAFIP: ActividadAFIP;
    tipoPersona: TipoPersona;
    cbUs: CBU[];
    viaDePago: ViaDePago;

    detalle: string;
    usuarioCreo: string;
    usuarioAprobo: string;
    lastUpdated?: string;

    modificacionPendiente: boolean;

    archivosAdjuntos: string[];
}
